import { useFlags } from 'launchdarkly-react-client-sdk';
import { AssistantLauncher } from './AssistantLauncher';
import { AssistantPanel } from './AssistantPanel';
import { useAssistant } from './AssistantProvider';
import { ASSISTANT_FLAG_KEY } from './constants';

/**
 * Launcher + panel, mounted only while the flag is on and the customer is on
 * an assistant-enabled step (income verification in iteration 1).
 * Must be rendered inside AssistantProvider.
 */
export function ApplicationAssistant() {
  const flags = useFlags<Record<string, boolean>>();
  const { isEnabledOnStep, isWideEnough, isOpen, ratingStage } = useAssistant();

  // An armed rating prompt still renders past isEnabledOnStep going false (step exit) —
  // but never past isWideEnough going false (viewport must hide everything).
  const showingRatingPrompt = ratingStage !== 'none';

  if (!flags[ASSISTANT_FLAG_KEY] || !isWideEnough || (!isEnabledOnStep && !showingRatingPrompt)) {
    return null;
  }

  return <>{isOpen ? <AssistantPanel /> : <AssistantLauncher />}</>;
}
